export const requestTypes = ["GET", "POST", "PUT", "DELETE"];
export const fields = [
  {
    label: "Workspace Id",
    value: "workspaceId",
  },
  {
    label: "Content Type Id",
    value: "contentTypeId",
  },
  {
    label: "Entry Id",
    value: "entryId",
  },
];

export const operators = [
  {
    label: "Equals",
    value: "eq",
  },
  {
    label: "Not Equals",
    value: "neq",
  },
  {
    label: "Contains",
    value: "contains",
  },
  {
    label: "Starts With",
    value: "startsWith",
  },
  {
    label: "Ends With",
    value: "endsWith",
  },
  {
    label: "Greater Than",
    value: "gt",
  },
  {
    label: "Greater Than or Equal",
    value: "gte",
  },
  {
    label: "Less Than",
    value: "lt",
  },
  {
    label: "Less Than or Equal",
    value: "lte",
  },
  {
    label: "In List",
    value: "in",
  },
  {
    label: "Not In List",
    value: "notIn",
  },
  {
    label: "Is Empty",
    value: "isNull",
  },
  {
    label: "Is Not Empty",
    value: "isNotNull",
  },
];
